'use client';

import { SymbolDisplay } from '@flipster/features/src/misc/display';
import { hstack } from '@flipster/styled-system/patterns';

export const Display = ({ symbol }: { symbol: string }) => {
  return (
    <SymbolDisplay
      symbol={symbol}
      icon={<SymbolDisplay.Icon size={32} space={8} />}
      mainLabel={
        <div className={hstack({ gap: 4, color: 'content.default.level-5', textStyle: 'Title/M' })}>
          <SymbolDisplay.Label value='shortName' />
          <SymbolDisplay.Label value='fullName' withParentheses />
        </div>
      }
    />
  );
};
